import { useEffect, useState, useMemo } from "react";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import api from "../lib/api";

export default function Contact() {
  const [settings, setSettings] = useState(null);
  const socialLinks = useMemo(() => Object.entries(settings?.links || {}).filter(([, v]) => v), [settings]);
  useEffect(() => { api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  const name = settings?.business_name || "DreamCots";

  const cards = [
    settings?.phone && { icon: Phone, bg: "#A3E635", label: "Call us", value: settings.phone, href: `tel:${settings.phone}` },
    settings?.whatsapp && { icon: MessageCircle, bg: "#FCD34D", label: "WhatsApp", value: settings.whatsapp, href: `https://wa.me/${settings.whatsapp.replace(/\D/g, "")}` },
    settings?.email && { icon: Mail, bg: "#93C5FD", label: "Email", value: settings.email, href: `mailto:${settings.email}` },
    settings?.address && { icon: MapPin, bg: "#FDBA74", label: "Address", value: settings.address },
  ].filter(Boolean);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-14">
      <p className="nb-label" style={{ letterSpacing: "0.2em" }}>Contact Us</p>
      <h1 data-testid="contact-heading" className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-2">Get in touch with {name}</h1>
      <p className="mt-4 text-slate-600">Questions about listings, rankings or paid packages? We'd love to help.</p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-6">
        {cards.map(({ icon: Icon, bg, label, value, href }) => (
          <a key={label} href={href || "#!"} data-testid={`contact-${label.toLowerCase().replace(/\s/g, "-")}`}
            target={href?.startsWith("http") ? "_blank" : undefined} rel="noreferrer"
            className="nb p-6 block hover:-translate-y-0.5 transition-transform duration-150" style={{ background: bg }}>
            <span className="w-11 h-11 rounded-xl border-2 border-[#171B33] bg-white flex items-center justify-center"><Icon className="w-5 h-5" /></span>
            <p className="nb-label mt-4">{label}</p>
            <p className="font-display font-extrabold mt-1 break-words">{value}</p>
          </a>
        ))}
      </div>
      {socialLinks.length > 0 && (
        <div className="mt-10">
          <p className="nb-label mb-3">Follow us</p>
          <div className="flex flex-wrap gap-3">
            {socialLinks.map(([k, v]) => (
              <a key={k} href={v} target="_blank" rel="noreferrer" data-testid={`contact-social-${k}`} className="nb-chip capitalize">{k}</a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
